import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning")({
  beforeLoad: () => {
    throw redirect({ to: "/$service", params: { service: "roof-washing" }, statusCode: 301 });
  },
});
